import { Injectable } from "@angular/core";
import { Utility } from "./_service/utility";


@Injectable()
export class ScrollStoreProvider{
    public storage=[];

    public sameRoutePrefix=["play","space"];
    constructor(private _utility:Utility) {

    }

    private translateKey(key)
    {
        if(!key)
        {
            key = "/";
        };

        for(var i = 0 ; i< this.sameRoutePrefix.length;++i)
        {
            if(key.indexOf(this.sameRoutePrefix[i]) > -1)
            {
                key = this.sameRoutePrefix[i];
                break;
            }
        }
        
        //console.log(key);
        return key;
    }

    public restoreScroll(key: string)
    {
        var result = 0;
        var exist = false;
        key = this.translateKey(key);
        if (this.storage.length > 0 && this.storage[this.storage.length -1].key == key)
        {
           // console.log("restore to " , this.storage[this.storage.length -1]);
            result = this.storage[this.storage.length -1].position;
            this.storage.splice(this.storage.length - 1,1);
            exist = true;
        }
        return {
            exist:exist,
            position:result

        }
    }

    public handleScroll(key: string) 
    {
        var path = key;
        var matchkey = this.translateKey(key);

        if(this.storage.length >100)
        {
            this.storage.splice(-1,1);
        }

        var position = this._utility.getWindow().scrollY;
        //console.log(matchkey)
        if(matchkey != "play")
        {
            if(this.storage.length > 0 && this.storage[this.storage.length - 1].key == matchkey)
            {
                
                this.storage[this.storage.length - 1] = {
                    key:matchkey,
                    path:key,
                    position:position
    
                };
            }
            else
            {
                this.storage.push({
                    key:matchkey,
                    path:key,
                    position:position
                });
            }
        }
      
    
      // console.log(this.storage);
    }
}